// Id de "Permiso especial de permanencia para tutores" en el catálogo de proveedores (varía por ambiente)
export const PROVIDER_PC_ID = Number(process.env.REACT_APP_PROVIDER_DOC_PC_ID) || null

export const VALUES = {
   MENU: {
      OPEN_MAIN_DRAWER_WIDTH: 380,
      CLOSED_MAIN_DRAWER_WIDTH: 56
   },
   // Se convirte de minutos a milisegundos:
   SESSION_TIME_EXPIRATION: 15 * 60 * 1000,
   NOTIFICATIONS_SUMMARY_MAX_ITEMS: 10,
   USER_TYPE: {
      INTERNAL: 'I',
      EXTERNAL: 'E'
   },
   STATUS_OPTIONS: [
      { value: 'A', label: 'Activo' },
      { value: 'I', label: 'Inactivo' }
   ],
   DOMAIN_OPTIONS: [
      { value: 'PRIVATE', label: 'Privado' },
      { value: 'EXTERNAL', label: 'Externo' },
      { value: 'EXTENDED', label: 'Extendido' }
   ],
   APPLICATION_TYPE_OPTIONS: [
      { value: 'I', label: 'Interna' },
      { value: 'E', label: 'Externa' },
      { value: 'M', label: 'Mixta' }
   ],
   FORM_BEHAVIOR: {
      REGISTER: 'REGISTER',
      SEARCH: 'SEARCH',
      EDIT: 'EDIT'
   },
   OPERATION_TYPES: [
      { value: 'A', label: 'Adjuntar' },
      { value: 'CA', label: 'Cargar Archivo' },
      { value: 'C', label: 'Consultar' },
      { value: 'E', label: 'Exportar' },
      { value: 'GR', label: 'Generar Reporte' },
      { value: 'L', label: 'Limpiar' },
      { value: 'P', label: 'Procesar' },
      { value: 'R', label: 'Registrar' },
      { value: 'VD', label: 'Ver Detalle' },
      { value: 'VDR', label: 'Ver Detalle / Registrar' }
   ],
   DOCUMENTS_TYPES: [
      { value: 'TI', label: 'Tarjeta de identidad' },
      { value: 'CC', label: 'Cédula de ciudadanía' },
      { value: 'CD', label: 'Carné diplomático' },
      { value: 'CE', label: 'Cédula de extranjería' },
      { value: 'NI', label: 'NIT' },
      {
         value: 'PA',
         label: 'Pasaporte expedido por el país de origen, sólo para extranjeros'
      },
      { value: 'PE', label: 'Permiso especial de permanencia' },
      { value: 'SC', label: 'Salvoconducto de permanencia' },
      { value: 'PT', label: 'Permiso por protección temporal' },
      { value: 'PC', label: 'Permiso especial de permanencia para tutores' }
   ],
   DOCUMENTS_TYPES_PROVIDER: [
      { value: 9, label: 'Cédula de ciudadanía' },
      { value: 10, label: 'Cédula de extranjería' },
      { value: 11, label: 'Permiso especial de permanencia' },
      { value: 12, label: 'NIT' },
      ...(PROVIDER_PC_ID ? [{ value: PROVIDER_PC_ID, label: 'Permiso especial de permanencia para tutores' }] : [])
   ],
   PERSON_TYPE_PROVIDER: [
      { value: 24, label: 'Natural' },
      { value: 23, label: 'Jurídica' }
   ],
   ASSOCIATE_TYPE: [
      { value: 'AP', label: 'Aportante' },
      { value: 'ASOCIADO', label: 'Asociado' },
      { value: 'COLABORADOR', label: 'Colaborador MutualSer' },
      { value: 'PROVEEDOR', label: 'Proveedor' }
   ],
   LEGAL_NATURE_TYPE: [
      { value: 'N', label: 'Natural' },
      { value: 'J', label: 'Jurídica' }
   ],
   PAGINATION_CONFIG: {
      labelRowsPerPage: 'Filas por página',
      labelRowsSelect: 'Filas por página',
      firstAriaLabel: 'Primera página',
      firstTooltip: 'Primera página',
      previousAriaLabel: 'Página anterior',
      previousTooltip: 'Página anterior',
      nextAriaLabel: 'Siguiente página',
      nextTooltip: 'Siguiente página',
      lastAriaLabel: 'Última página',
      lastTooltip: 'Última página',
      labelDisplayedRows: '{from}-{to} de {count}'
   },
   // TODO: eliminar cuando no se use mas
   SNACKBAR_MESSAGE_INTIAL_STATE: {
      open: false,
      text: '',
      type: '',
      fontColor: ''
   },
   PAGING_ORDER_INITIAL_STATE: {
      page: 0,
      size: 5,
      order: 'asc',
      columnOrder: 'name'
   },
   TABLE_DATA_INTIAL_STATE: {
      data: [],
      pageSize: 1,
      pageNumber: 0,
      totalRows: 1
   },
   APP_RESOURCE_CODE: '8787e59b-4e7c-41b0-af51-d87550304d31',
   REGULATIONS_CODE: '28cb913a-d019-4f73-ac04-ce753adb485f',
   VIDEO_TUTORIALS_CODE: '4296bf8b-5e9b-4242-9b44-ac2a9da5e0a9'
}

export const INTERNAL_DOMAINS = [
   '@mutualser.com',
   '@mutualser.org',
   '@sersocial.org',
   '@sersocial.com'
]

export const RESTRICTED_EMAIL_DOMAINS = [
   '@yopmail.com',
   '@affinitybpo.com.co'
]

// TODO: NO usar, se eliminará
export const PATHS = {
   RIPS_IPS_FIND: '/supplier/find-by'
}

export const REGEXP = {
   /**
    * Password requirements
    * -No spaces: (?!.*[\s])
    * -At least 1 uppercase character: (?=.*?[A-Z])
    * -At least 1 number: (?=.*?[0-9])
    * -At least 1 special character: (?=.*?\W)
    * -Min 8 characters lenght: (?=.{8,}$)
    */
   PORTAL_PASSWORD: /^(?!.*[\s])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?\W)(?=.{8,}$).*$/,
   EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
   NAME_USER: /^[a-zA-ZÀ-ÿ\s]*$/,
   CELLPHONE: /^3\d{9}$/,
   TELEPHONE: /^[1-9]\d{0,6}$/,
   URL_RESOURCES:
      /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/,
   VALIDATION_NAME: /^[a-zA-ZñÑ\s]*$/,
   VALIDATION_NAME_WHIT_NUMBER: /^[a-zA-ZñÑ\s_0-9]*$/,
   CEDULA_CIUDADANIA_REGEX: /(^\d{6,9}$)|^(1|2)\d{9}$/,
   TARJETA_IDENTIDAD_REGEX: /^[1-9]\d{9,10}$/,
   CEDULA_EXTRANJERIA_REGEX: /^[a-zA-Z0-9]{3,7}$/,
   SALVOCONDUCTO_PERMANENCIA_REGEX: /^[a-zA-Z0-9]{3,9}$/,
   PASAPORTE_REGEX: /^[a-zA-Z0-9]{3,16}$/,
   CARNE_DIPLOMATICO_REGEX: /^[a-zA-Z0-9]{3,11}$/,
   PERMISO_ESPECIAL_PERMANENCIA_REGEX: /^\d{15}$/,
   NIT_REGEX: /^\d{9}$/,
   PERMISO_PROTECCION_TEMPORAL_REGEX: /^\d{16}$/,
   PERMISO_ESPECIAL_PERMANENCIA_TUTORES_REGEX: /^\d{1,8}$/
}

//length must be syncronized with docTypes regex
export const DOC_TYPES_LENGTH = {
   NI: [9, 9],
   CC: [6, 10],
   CE: [3, 7],
   PA: [3, 16],
   TI: [10, 11],
   CD: [3, 11],
   SC: [3, 9],
   PE: [15, 15],
   PT: [16, 16],
   PC: [1, 8],
   ...(PROVIDER_PC_ID && { [PROVIDER_PC_ID]: [1, 8] })
}

export const GOOGLE_UA_ENV = {
   dev: 'G-JP1FN758DF',
   qa: 'G-T19RXS364V',
   prod: 'G-JP1FN758DF'
}

// NOTA: Estas keys son borradas del localstorage al hacer logout
export const LOCALSTORAGE_KEYS = {
   USER_SETTINGS: 'user_settings',
   TOKEN_APP: 'token_app',
   STATE: 'state'
}

// TODO: NO usar, se están eliminando
const TRANSLATE = {
   LABELS: {
      ASSIGNED_ROLES: 'Roles Asignados',
      LINK_GROUPS_TO_ROLES_AND_USERS: 'Relacionar Grupos a Usuarios',
      NO_RESULTS: 'No hay registros que mostrar',
      NO_RESULTS_SEARCH_GROUP: 'No hay coincidencia para esta consulta',
      SEARCH_RESULTS: 'Resultado de la consulta',
      FILTERED_BY: 'FILTRADO POR:',
      FILE_DRAG_LEGEND: 'Arrastra y suelta o carga tu archivo %n% desde tu equipo.'
   },
   BUTTONS: {
      ROLES: 'Roles',
      APPLY: 'APLICAR',
      ACCEPT: 'ACEPTAR',
      CANCEL: 'CANCELAR',
      LOGIN: 'INGRESAR',
      SAVE: 'GUARDAR',
      SEARCH: 'CONSULTAR',
      EDIT: 'ACTUALIZAR',
      FORGOT_PASSWORD: '¿Olvidaste tu Clave de Acceso?',
      LOGOUT: 'Salir',
      CHANGE_PASSWORD: 'Cambiar contraseña',
      SITE_POLICIES: 'Políticas del sitio',
      CLEAN: 'LIMPIAR',
      REGISTRATION_REQUEST: 'SOLICITUD DE REGISTRO'
   },
   API_MESSAGES: {
      ROLES: {
         GET_ERROR: 'Lo sentimos, hubo un problema al consultar los roles',
         POST_SUCCESS: 'Se guardaron los roles exitosamente',
         POST_ERROR: 'Lo sentimos, hubo un problema al guardar los roles',
         GET_ERROR_ROL_OPERATION: 'Lo sentimos, hubo un problema al consultar las relaciones de rol a operaciones',
         POST_ERROR_ROL_OPERATION: 'Lo sentimos, hubo un error relacionando el rol a las operaciones'
      },
      LOGIN: {
         IVALID_USER_OR_PASSWORD: 'Su usuario o contraseña son incorrectos, por favor verifique',
         INVALID_USER_SETTINGS: 'Se presentó un error al consultar las configuraciones del usuario'
      },
      ENTITIES: {
         GET_ERROR: 'Lo sentimos, hubo un problema al consultar el listado de entidades'
      },
      GROUPS: {
         GET_ERROR_ASSIGN: 'Se presentó un error consultando los grupos, los usuarios o los roles',
         GET_ERROR: 'Lo sentimos, hubo un problema al consultar el grupo',
         POST_ERROR_ASSIGN: 'Se prensetó un error guardando la relacion de grupos a roles y usuarios',
         POST_SUCCESS: 'El grupo se guardó correctamente',
         POST_ERROR: 'Lo sentimos, hubo un problema al registrar el grupo'
      },
      SLIDER: {
         GET_ERROR: 'Se presentó un error consultando la publicidad del banner'
      }
   },
   FORM: {
      NO_MORE_THAN_N_CHARACTERS: 'El número permitido de caracteres es de máximo %n%.',
      MINIMUM_N_CHARACTERS: 'El número permitido de caracteres es de mínimo %n%.',
      ENTER_VALID_NAME_MESSAGE: 'Por favor ingrese un nombre válido.',
      MANDATORY_SUBDOMAIN_MESSAGE: 'El campo Nombre del subdominio es obligatorio.',
      VALID_DESCRIPTION_MESSAGE: 'Por favor ingrese una descripción válida.',
      SUBDOMAIN_SUCCESSFULLY_SAVED: 'Se guardó correctamente el Subdominio.',
      EXIT_CONFIRMATION: '¿Está seguro que desea salir del Portal ZonaSer?',
      SELECT_VALID_ROLE: 'El campo Roles es obligatorio',
      SELECT_VALID_USER: 'El campo Usuarios es obligatorio',
      SELECT_VALID_GROUP: 'El campo Grupo es obligatorio',
      REQUIRED_FIELDS: 'Los campos en rojo son requeridos, complete la información.'
   },
   TABLE: {
      NO_RECORDS_TO_DISPLAY: 'No hay registros que mostrar'
   }
}

export default TRANSLATE

//OPERATIONS
export const OPERACIONES_SUBDOMINIOS = {
   CONSULTAR_SUBDOMINIO: 'dfb93328-4325-11ec-9427-0a80ff2603de',
   EDITAR_SUBDOMINIO: 'e8715b20-3448-4bee-bf8b-6a2dfb2272ce',
   REGISTRAR_SUBDOMINIO: 'dfb93206-4325-11ec-9427-0a80ff2603de',
   VER_CODIGO_SUBDOMINIO: '177812a5-3b67-4577-b196-e1407add2f2e'
}

export const OPERACIONES_APLICACIONES = {
   CONSULTAR_APLICACION: 'dfb93418-4325-11ec-9427-0a80ff2603de',
   EDITAR_APLICACION: '50b1c2ef-7441-48ad-ba73-b9c6b91654b3',
   REGISTRAR_APLICACION: 'dfb933aa-4325-11ec-9427-0a80ff2603de',
   VER_CODIGO_APLICACION: '262674f7-3fb4-4fcf-8b52-9f23995fb61d',
   CARGAR_MANUAL_APLICACION: 'af1cf0ab-9b96-4035-8a5c-0b4db06b4f65'
}

export const OPERACIONES_MODULOS = {
   CONSULTAR_MODULOS: 'dfb93526-4325-11ec-9427-0a80ff2603de',
   REGISTRAR_MODULOS: 'dfb93486-4325-11ec-9427-0a80ff2603de',
   EDITAR_MODULO: '487901b6-54c2-40e1-8e03-81777130758e',
   VER_CODIGO_MODULOS: '701880be-eeba-4bb0-9e80-a2e8a42690b7'
}

export const OPERACIONES_FUNCIONALIDAD = {
   REGISTRAR: 'dfb93594-4325-11ec-9427-0a80ff2603de',
   CONSULTAR: 'dfb93602-4325-11ec-9427-0a80ff2603de',
   EDITAR: '07a59e2f-9dd4-4c0a-8754-35d1476c4b36',
   VER_CODIGO: '129a3234-c616-4357-940b-24c2795e28e1',
   CARGAR_VIDEO: '236d3fec-4004-4ec5-baf2-b54f487a43d0'
}

export const OPERACIONES_OPERACION = {
   CONSULTAR: 'dfb936d4-4325-11ec-9427-0a80ff2603de',
   REGISTRAR: 'dfb93666-4325-11ec-9427-0a80ff2603de',
   EDITAR: 'e0abbafb-abc2-4003-8992-bd1d22f77ff5',
   VER_CODIGO: '9c5bbeb5-72c5-489f-9755-b82b80cd13eb'
}

export const OPERACIONES_ROLES = {
   REGISTRAR: 'dfb93738-4325-11ec-9427-0a80ff2603de',
   CONSULTAR: 'dfb9379c-4325-11ec-9427-0a80ff2603de',
   EDITAR: '061eb49c-8207-4560-b56a-ccaadd79fb0c',
   VER_CODIGO: '58a7beea-d609-4c28-bd3a-86d7cf60f2dc',
   RELACIONAR_ROL_A_OPERACION: 'dfb9380a-4325-11ec-9427-0a80ff2603de',
   IMPORTAR: 'dfb9386e-4325-11ec-9427-0a80ff2603de',
   EXPORTAR: 'dfb938d2-4325-11ec-9427-0a80ff2603de'
}

export const OPERACIONES_GRUPOS = {
   REGISTAR: 'dfb93936-4325-11ec-9427-0a80ff2603de',
   CONSULTAR: 'dfb939a4-4325-11ec-9427-0a80ff2603de',
   EDITAR: 'c4ff3455-69c4-4e65-a47e-3a29e11fa8a6',
   VER_USUARIOS: '70e6ff5c-4982-400c-b9b8-8494dc27a756',
   VER_CODIGO: 'a39a9e43-7f28-4745-b80a-e3079fffc312',
   RELACIONAR_GRUPOS_ROLES_USUARIOS: 'dfb93a12-4325-11ec-9427-0a80ff2603de'
}

export const OPERACIONES_USUARIO = {
   REGISTRAR: 'dfb93a76-4325-11ec-9427-0a80ff2603de',
   REGISTRAR_ADM: '89774591-c0c9-4a96-b575-6403dcd8e975',
   CAMBIAR_ESTADO: 'c76d74e0-e972-474e-b51c-62b5e1c91e91',
   CONSULTAR: 'dfb93ada-4325-11ec-9427-0a80ff2603de',
   EDITAR: '64c8b2fa-8a50-439a-996e-f7a0734e9c38',
   VER_CODIGO: 'ef54756b-49a5-4613-99c9-d690a0145a41',
   VER_TRAZA: '443a50c6-5319-43a4-8399-038e04781fe5'
}
